import AthleticsBold from '@assets/Athletics Cuemath/Athletics Bold/Athletics-Bold.otf';
import AthleticsRegular from '@assets/Athletics Cuemath/Athletics Regular/Athletics-Regular.otf';

export async function loadFonts() {
  const fonts = [
    // If the font is not working, just remove the weight and try again.
    new FontFace('Athletics-Bold', `url(${AthleticsBold}) format('opentype')`, {
      weight: '28.8',
    }),
    new FontFace('Athletics-Regular', `url(${AthleticsRegular}) format('opentype')`),
  ];
  await Promise.all(fonts.map(font => font.load()));
  fonts.forEach(font => document.fonts.add(font));
}
